import { manageError, manageResponse } from './api-util'
import { http } from './http'
import { httpS3 } from './httpS3'
import { DataFile } from '@/@types/global'

const updateUser = async (params: any): Promise<any> => {
  try {
    const response: MyResponse<any[]> = await http.post('/user', params)
    return manageResponse(response) as any[]
  } catch (error) {
    manageError(error)
  }
}

const getSignedUrlToPutFile = async (path: string) => {
  try {
    const response = await http.put('file', { path })
    return manageResponse(response) as string
  } catch (error) {
    manageError(error)
  }
}

const uploadFileToBucket = async (
  url: string,
  image: string | ArrayBuffer | null
) => {
  await httpS3.put(url, image)
}

const updateReportDocument = async (data: DataFile) => {
  try {
    const response = await http.put('report-document', data)
    return manageResponse(response) as string
  } catch (error) {
    manageError(error)
  }
}

export {
  updateUser,
  getSignedUrlToPutFile,
  uploadFileToBucket,
  updateReportDocument,
}
